// EditDealerProfile.jsx
import React, { useEffect, useState, useCallback, useRef } from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import axios from "axios";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import OpeningHours from "../components/OpeningHours";
import Cropper from "react-easy-crop";
import getCroppedImg from "../helper/cropImage";

const EditDealerProfile = () => {
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  const [data, setData] = useState();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [editing, setEditing] = useState(false);
  const [mapsLoaded, setMapsLoaded] = useState(false);

  // Refs for Google Autocomplete
  const addressAutocompleteRef = useRef(null);
  const addressInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);

  const baseUrl =
    window.CARLOCA_UPLOADS + "/users/";

  const [editedData, setEditedData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    dealerName: "",
    mobile: "",
    phone: "",
    dealer_website: "",
    addressFirst: "",
    addressSecond: "",
    city: "",
    country: "",
    postcode: "",
    dealerId: "",
    address: "",
    latitude: "",
    longitude: "",
    cardNo: "",
    expiry: "",
    cvv: "",
  });

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  const storedUserPreferences = getDataFromlocalStorage("userData");

  const handleInputChange = (field, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const saveDataTolocalStorage = (key, dataToSave) => {
    try {
      const serializedData = JSON.stringify(dataToSave);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };

  const updateUserDataInLocalStorage = (newData) => {
    try {
      const existingData = JSON.parse(localStorage.getItem("userData")) || {};
      const updated = {
        ...existingData,
        ...newData,
      };
      // Explicitly preserve existing token if no new token is returned
      if (!newData.token && existingData.token) {
        updated.token = existingData.token;
      }
      localStorage.setItem("userData", JSON.stringify(updated));
    } catch (error) {
      console.error("Error updating userData in localStorage:", error);
    }
  };

  const updateProfileDetails = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/user/update/profile",
        {
          user_id: storedUserPreferences?.id,
          email: editedData?.email,
          phone: editedData?.phone,
          dealer_website: editedData?.dealer_website,
          address: editedData?.address,
          addressFirst: editedData?.addressFirst,
          addressSecond: editedData?.addressSecond,
          city: editedData?.city,
          country: editedData?.country,
          postcode: editedData?.postcode,
          dealerId: editedData?.dealerId,
          first_name: editedData?.first_name,
          last_name: editedData?.last_name,
          dealerName: editedData?.dealerName,
          mobile: editedData?.mobile,
          latitude: editedData?.latitude,
          longitude: editedData?.longitude,
        }
      );

      if (response?.data?.status) {
        toast.success(response?.data?.message, optionToast);
        const mergedData = { ...response?.data?.data };
        if (response?.data?.token) mergedData.token = response?.data?.token;
        updateUserDataInLocalStorage(mergedData);
        fetchData(storedUserPreferences?.id);
        setEditing(false);
      } else {
        toast.error(response?.data?.message ?? "Update failed", optionToast);
      }
    } catch (error) {
      console.log("An error occurred while updating profile.", error);
      toast.error("An error occurred while updating profile.", optionToast);
    }
  };

  const closeModal = () => {
    const modal = document.getElementById("cropModal");
    if (modal) {
      modal.classList.remove("show");
      modal.style.display = "none";
    }
  };

  const handleProfile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        const modal = document.getElementById("cropModal");
        if (modal) {
          modal.classList.add("show");
          modal.style.display = "block";
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropImage = async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      handleProfileData(croppedImage);
      closeModal();
    } catch (error) {
      console.error("Error cropping image:", error);
    }
  };

  const handleProfileData = (selectedFile) => {
    const formData = {
      user_id: storedUserPreferences?.id,
      profile: selectedFile,
    };

    axios
      .post(
        window.CARLOCA_API + "/user/update/profile/picture",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message, optionToast);
          const mergedPic = { ...(res?.data?.user || res?.data?.data) };
          if (res?.data?.token) mergedPic.token = res?.data?.token;
          updateUserDataInLocalStorage(mergedPic);
          fetchData(storedUserPreferences?.id);
        } else {
          let errorMessage = res?.data?.message ?? "Upload failed";
          const errorData = res?.data?.error;
          if (errorData && typeof errorData === 'object' && Object.keys(errorData).length > 0) {
            const firstKey = Object.keys(errorData)[0];
            const firstErrorArr = errorData[firstKey];
            if (Array.isArray(firstErrorArr) && firstErrorArr.length > 0) {
              errorMessage = firstErrorArr[0];
            } else if (typeof firstErrorArr === 'string') {
              errorMessage = firstErrorArr;
            }
          }
          toast.error(errorMessage, optionToast);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSaveClick = () => {
    updateProfileDetails();
  };

  // --------------- Google Autocomplete & helpers ---------------
  const parseAddressComponents = (components) => {
    let addressFirst = "";
    let addressSecond = "";
    let city = "";
    let country = "";
    let postcode = "";

    for (const component of components) {
      const types = component.types || [];

      if (types.includes("street_number")) {
        addressFirst =
          component.long_name + (addressFirst ? ` ${addressFirst}` : "");
      } else if (types.includes("route")) {
        addressFirst = addressFirst
          ? `${addressFirst} ${component.long_name}`
          : component.long_name;
      } else if (types.includes("locality") || types.includes("postal_town")) {
        city = component.long_name;
      } else if (types.includes("administrative_area_level_2")) {
        addressSecond = component.long_name;
      } else if (types.includes("country")) {
        country = component.long_name;
      } else if (types.includes("postal_code")) {
        postcode = component.long_name;
      }
    }

    return { addressFirst, addressSecond, city, country, postcode };
  };

  const handlePlaceSelect = () => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current.getPlace();

    if (!place?.geometry || !place?.address_components) {
      toast.error("No details available for this address", optionToast);
      return;
    }

    const parsed = parseAddressComponents(place.address_components);

    setEditedData((prev) => ({
      ...prev,
      addressFirst: parsed.addressFirst,
      addressSecond: parsed.addressSecond,
      city: parsed.city,
      country: parsed.country,
      postcode: parsed.postcode,
      address: place.formatted_address || prev.address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
    }));
  };

  useEffect(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      setMapsLoaded(true);
      initAutocomplete();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector("#google-maps-script")) {
      // If script is already loading, wait for it to load
      const checkMapsLoaded = () => {
        if (window.google && window.google.maps && window.google.maps.places) {
          setMapsLoaded(true);
          initAutocomplete();
        } else {
          setTimeout(checkMapsLoaded, 100);
        }
      };
      setTimeout(checkMapsLoaded, 100);
      return;
    }

    // Load the Google Maps script
    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAonK15hotzDslX4ePjIbmizRii-7Ng4QE&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setMapsLoaded(true);
      initAutocomplete();
    };
    script.onerror = () => {
      toast.error("Failed to load Google Maps API", optionToast);
      console.error("Google Maps API failed to load");
    };
    document.head.appendChild(script);
    fetchData(storedUserPreferences?.id);
    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current
        );
      }
    };
  }, []);

  // Initialize autocomplete when maps are loaded and component is mounted
  useEffect(() => {
    if (mapsLoaded && inputRef.current) {
      initAutocomplete();
    }
  }, [mapsLoaded, editing]);
  useEffect(() => {
    fetchData(storedUserPreferences?.id);
  }, []);
  const initAutocomplete = () => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps API not loaded");
      return;
    }

    if (inputRef.current) {
      // Set options for the autocomplete - restrict to UK addresses
      const options = {
        types: ["geocode"],
        componentRestrictions: { country: "uk" },
      };

      // Clear previous autocomplete instance if exists
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current
        );
      }

      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        options
      );

      // Add event listener for when a place is selected
      autocompleteRef.current.addListener("place_changed", handlePlaceSelect);
    }
  };

  const fetchData = async (userId) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/user/get/details",
        {
          user_id: storedUserPreferences?.id,
        }
      );
      setData(response?.data);

      if (response?.data?.status) {
        const d = response?.data?.data || {};
        setEditedData({
          email: d?.email || "",
          first_name: d?.first_name || "",
          last_name: d?.last_name || "",
          dealerName: d?.dealerName || "",
          phone: d?.phone || "",
          mobile: d?.mobile || "",
          dealer_website: d?.dealer_website || "",
          dealerId: d?.dealerId || "",
          addressFirst: d?.address_first || d?.addressFirst || "",
          addressSecond: d?.address_second || d?.addressSecond || "",
          city: d?.city || "",
          country: d?.country || "",
          postcode: d?.postcode || "",
          address: d?.address || "",
          latitude: d?.latitude ?? d?.lat ?? d?.latitude_coord ?? "",
          longitude:
            d?.longitude ?? d?.lng ?? d?.lon ?? d?.longitude_coord ?? "",
          cardNo: d?.bank?.card_number || "",
          expiry: d?.bank?.expiry || "",
          cvv: d?.bank?.cvv || "",
        });
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };

  function backto() {
    window.history.back();
  }

  // Fallback reverse geocoding via OpenStreetMap Nominatim
  const reverseGeocodeWithNominatim = async (lat, lon) => {
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(
        lat
      )}&lon=${encodeURIComponent(lon)}&addressdetails=1`;
      const res = await fetch(url, {
        headers: {
          "User-Agent": "Trusted Cars-App - user@example.com", // change to your contact
        },
      });
      if (!res.ok) return null;
      const json = await res.json();
      const address = json?.address || {};
      // Nominatim gives many fields, map the important ones
      return {
        formatted_address: json?.display_name || "",
        addressFirst:
          (address.house_number ? `${address.house_number} ` : "") +
          (address.road || address.pedestrian || address.cycleway || ""),
        addressSecond: address.county || address.state || "",
        city:
          address.city ||
          address.town ||
          address.village ||
          address.municipality ||
          "",
        country: address.country || "",
        postcode: address.postcode || "",
      };
    } catch (err) {
      console.error("Nominatim reverse geocode failed", err);
      return null;
    }
  };

  // geolocation helper with reverse geocoding (Google first, then fallback)
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser", optionToast);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = parseFloat(pos.coords.latitude);
        const lng = parseFloat(pos.coords.longitude);

        handleInputChange("latitude", String(lat));
        handleInputChange("longitude", String(lng));

        // Try Google reverse geocode if available
        if (
          window.google &&
          window.google.maps &&
          window.google.maps.Geocoder
        ) {
          try {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode(
              { location: { lat, lng } },
              async (results, status) => {
                if (status === "OK" && results && results[0]) {
                  const place = results[0];
                  const parsed = parseAddressComponents(
                    place.address_components || []
                  );
                  setEditedData((prev) => ({
                    ...prev,
                    city: parsed.city || prev.city,
                    country: parsed.country || prev.country,
                    postcode: parsed.postcode || prev.postcode,
                    addressFirst: parsed.addressFirst || prev.addressFirst,
                    addressSecond: parsed.addressSecond || prev.addressSecond,
                    address: place.formatted_address || prev.address,
                  }));
                } else {
                  // fallback to nominatim
                  const nomRes = await reverseGeocodeWithNominatim(lat, lng);
                  if (nomRes) {
                    setEditedData((prev) => ({
                      ...prev,
                      city: nomRes.city || prev.city,
                      country: nomRes.country || prev.country,
                      postcode: nomRes.postcode || prev.postcode,
                      addressFirst: nomRes.addressFirst || prev.addressFirst,
                      addressSecond: nomRes.addressSecond || prev.addressSecond,
                      address: nomRes.formatted_address || prev.address,
                    }));
                  } else {
                    toast.info(
                      "Location coordinates set but address parsing failed",
                      optionToast
                    );
                  }
                }
              }
            );
          } catch (e) {
            console.warn("Google geocoder failed, using fallback", e);
            const nomRes = await reverseGeocodeWithNominatim(lat, lng);
            if (nomRes) {
              setEditedData((prev) => ({
                ...prev,
                city: nomRes.city || prev.city,
                country: nomRes.country || prev.country,
                postcode: nomRes.postcode || prev.postcode,
                addressFirst: nomRes.addressFirst || prev.addressFirst,
                addressSecond: nomRes.addressSecond || prev.addressSecond,
                address: nomRes.formatted_address || prev.address,
              }));
            }
          }
        } else {
          // fallback: use Nominatim
          const nomRes = await reverseGeocodeWithNominatim(lat, lng);
          if (nomRes) {
            setEditedData((prev) => ({
              ...prev,
              city: nomRes.city || prev.city,
              country: nomRes.country || prev.country,
              postcode: nomRes.postcode || prev.postcode,
              addressFirst: nomRes.addressFirst || prev.addressFirst,
              addressSecond: nomRes.addressSecond || prev.addressSecond,
              address: nomRes.formatted_address || prev.address,
            }));
          } else {
            toast.info(
              "Location coordinates set but address parsing failed",
              optionToast
            );
          }
        }

        toast.success("Location fetched successfully", optionToast);
      },
      (err) => {
        console.error(err);
        toast.error("Unable to fetch location", optionToast);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  // validate numeric coords for embed
  const coordsAreValid = (lat, lng) => {
    if (lat === "" || lng === "" || lat == null || lng == null) return false;
    const la = parseFloat(lat);
    const lo = parseFloat(lng);
    return (
      !Number.isNaN(la) &&
      !Number.isNaN(lo) &&
      Math.abs(la) <= 90 &&
      Math.abs(lo) <= 180
    );
  };

  return (
    <>
      <Navbar />

      <div className="ps-page">
        <div className="container px-0">
          <div className="ps-wrapper">

            {/* â”€â”€ Hero Card â”€â”€ */}
            <div className="ps-hero-card ps-hero-dealer">
              <button onClick={backto} className="ps-back-btn">
                <i className="fa fa-arrow-left me-1"></i>Back
              </button>
              <div className="ps-avatar-wrap">
                <img
                  className="ps-avatar"
                  alt="Dealer profile"
                  src={
                    data?.data?.profile === undefined || data?.data?.profile === null
                      ? "img/user_default.png"
                      : `${baseUrl}${data?.data?.profile}`
                  }
                />
                <label htmlFor="upload-img" className="ps-avatar-edit" title="Change photo">
                  <i className="fa-solid fa-camera"></i>
                </label>
                <input id="upload-img" onChange={handleProfile} type="file" style={{ display: "none" }} />
              </div>
              <h4 className="ps-name">
                {editedData.dealerName || `${data?.data?.first_name || ""} ${data?.data?.last_name || ""}`.trim() || "Dealer"}
              </h4>
              <span className="ps-role-badge"><i className="fa-solid fa-store me-1"></i>Dealer Account</span>
            </div>

            {/* â”€â”€ Quick Navigation â”€â”€ */}
            <div className="ps-quick-nav">
              <Link to="/dealer/dashboard" className="ps-quick-btn">
                <i className="fa-solid fa-gauge me-2"></i>Dashboard
              </Link>
              <Link to="/dealer/all-cars" className="ps-quick-btn">
                <i className="fa-solid fa-car me-2"></i>My Cars
              </Link>
              <Link to="/dealer/my-inventory" className="ps-quick-btn">
                <i className="fa-solid fa-warehouse me-2"></i>Inventory
              </Link>
              <Link to="/dealer/store" className="ps-quick-btn">
                <i className="fa-solid fa-shop me-2"></i>My Store
              </Link>
              <Link to="/dealer/all-offers" className="ps-quick-btn">
                <i className="fa-solid fa-handshake me-2"></i>Offers
              </Link>
            </div>

            {/* â”€â”€ Business & Contact Details â”€â”€ */}
            <div className="ps-card">
              <div className="ps-card-header">
                <div>
                  <h6 className="ps-card-title">
                    <i className="fa-solid fa-building me-2" style={{ color: "#00889c" }}></i>
                    Business &amp; Contact Details
                  </h6>
                  <p className="ps-card-subtitle">Shown on your dealership listing page</p>
                </div>
                <button
                  className={`ps-edit-btn${editing ? " ps-edit-btn-active" : ""}`}
                  onClick={!editing ? () => setEditing(true) : handleSaveClick}
                >
                  {editing
                    ? <><i className="fa-solid fa-check me-1"></i>Save</>
                    : <><i className="fa-solid fa-pen me-1"></i>Edit</>}
                </button>
              </div>

              {editing ? (
                <div className="ps-fields">
                  <div className="row g-3">
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">First Name</label>
                        <input type="text" value={editedData.first_name}
                          onChange={(e) => handleInputChange("first_name", e.target.value)}
                          className="form-control ps-input" placeholder="First name" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Last Name</label>
                        <input type="text" value={editedData.last_name}
                          onChange={(e) => handleInputChange("last_name", e.target.value)}
                          className="form-control ps-input" placeholder="Last name" />
                      </div>
                    </div>
                  </div>
                  <div className="ps-field-group mt-3">
                    <label className="ps-field-label">Dealership Name</label>
                    <input type="text" value={editedData.dealerName}
                      onChange={(e) => handleInputChange("dealerName", e.target.value)}
                      className="form-control ps-input" placeholder="Trading name" />
                  </div>
                  <div className="ps-field-group">
                    <label className="ps-field-label">Email</label>
                    <input type="email" value={editedData.email}
                      onChange={(e) => handleInputChange("email", e.target.value)}
                      className="form-control ps-input" placeholder="Email address" />
                  </div>
                  <div className="row g-3">
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Phone</label>
                        <input type="tel" value={editedData.phone}
                          onChange={(e) => handleInputChange("phone", e.target.value)}
                          className="form-control ps-input" placeholder="Landline" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Mobile</label>
                        <input type="tel" value={editedData.mobile}
                          onChange={(e) => handleInputChange("mobile", e.target.value)}
                          className="form-control ps-input" placeholder="Mobile" />
                      </div>
                    </div>
                  </div>
                  <div className="ps-field-group mt-3">
                    <label className="ps-field-label">Website</label>
                    <input type="url" value={editedData.dealer_website}
                      onChange={(e) => handleInputChange("dealer_website", e.target.value)}
                      className="form-control ps-input" placeholder="https://www.example.co.uk" />
                  </div>
                  <div className="ps-field-group">
                    <label className="ps-field-label">Address Search</label>
                    <input type="text" ref={inputRef}
                      placeholder="Start typing your dealership address..."
                      className="form-control ps-input mb-2" />
                    <button type="button" onClick={getCurrentLocation} className="ps-location-btn">
                      <i className="fa-solid fa-location-crosshairs me-1"></i>Use My Location
                    </button>
                  </div>
                  <div className="row g-3">
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Address Line 1</label>
                        <input type="text" value={editedData.addressFirst}
                          onChange={(e) => handleInputChange("addressFirst", e.target.value)}
                          className="form-control ps-input" placeholder="Street name" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Address Line 2</label>
                        <input type="text" value={editedData.addressSecond}
                          onChange={(e) => handleInputChange("addressSecond", e.target.value)}
                          className="form-control ps-input" placeholder="County / Area" />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">City</label>
                        <input type="text" value={editedData.city}
                          onChange={(e) => handleInputChange("city", e.target.value)}
                          className="form-control ps-input" placeholder="City" />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Country</label>
                        <input type="text" value={editedData.country}
                          onChange={(e) => handleInputChange("country", e.target.value)}
                          className="form-control ps-input" placeholder="Country" />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Post Code</label>
                        <input type="text" value={editedData.postcode}
                          onChange={(e) => handleInputChange("postcode", e.target.value)}
                          className="form-control ps-input" placeholder="SW1A 1AA" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="ps-field-group mb-0">
                        <label className="ps-field-label">Dealer ID</label>
                        <input type="text" value={editedData.dealerId}
                          onChange={(e) => handleInputChange("dealerId", e.target.value)}
                          className="form-control ps-input" placeholder="Dealer identifier" />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ps-info-grid">
                  {(editedData.first_name || editedData.last_name) && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-user me-1"></i>Name</span>
                      <span className="ps-info-value">{editedData.first_name} {editedData.last_name}</span>
                    </div>
                  )}
                  {editedData.dealerName && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-store me-1"></i>Dealership</span>
                      <span className="ps-info-value">{editedData.dealerName}</span>
                    </div>
                  )}
                  {editedData.email && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-envelope me-1"></i>Email</span>
                      <span className="ps-info-value">{editedData.email}</span>
                    </div>
                  )}
                  {editedData.phone && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-phone me-1"></i>Phone</span>
                      <span className="ps-info-value">{editedData.phone}</span>
                    </div>
                  )}
                  {editedData.mobile && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-mobile-screen me-1"></i>Mobile</span>
                      <span className="ps-info-value">{editedData.mobile}</span>
                    </div>
                  )}
                  {editedData.dealer_website && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-globe me-1"></i>Website</span>
                      <a href={editedData.dealer_website} target="_blank" rel="noopener noreferrer"
                        className="ps-info-value"
                        style={{ textDecoration: "none", wordBreak: "break-all" }}>
                        {editedData.dealer_website}
                      </a>
                    </div>
                  )}
                  {editedData.addressFirst && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-location-dot me-1"></i>Address</span>
                      <span className="ps-info-value">
                        {[editedData.addressFirst, editedData.addressSecond, editedData.city, editedData.postcode]
                          .filter(Boolean).join(", ")}
                      </span>
                    </div>
                  )}
                  {editedData.country && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-flag me-1"></i>Country</span>
                      <span className="ps-info-value">{editedData.country}</span>
                    </div>
                  )}
                  {editedData.dealerId && (
                    <div className="ps-info-item">
                      <span className="ps-info-label"><i className="fa-solid fa-id-badge me-1"></i>Dealer ID</span>
                      <span className="ps-info-value">{editedData.dealerId}</span>
                    </div>
                  )}
                  {!editedData.email && !editedData.phone && (
                    <div className="ps-empty-state">
                      <i className="fa-solid fa-pen-to-square me-2"></i>
                      Tap <strong>Edit</strong> to complete your dealership profile
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* â”€â”€ Opening Hours â”€â”€ */}
            <div className="ps-card">
              <div className="ps-card-header">
                <div>
                  <h6 className="ps-card-title">
                    <i className="fa-solid fa-clock me-2" style={{ color: "#00889c" }}></i>
                    Opening Hours
                  </h6>
                  <p className="ps-card-subtitle">When customers can visit your dealership</p>
                </div>
              </div>
              <div className="ps-fields pt-0">
                <OpeningHours /></div>

            </div>

            {/* â”€â”€ Map Preview â”€â”€ */}
            {coordsAreValid(editedData.latitude, editedData.longitude) && (
              <div className="ps-card">
                <div className="ps-card-header">
                  <div>
                    <h6 className="ps-card-title">
                      <i className="fa-solid fa-map-location-dot me-2" style={{ color: "#00889c" }}></i>
                      Dealership Location
                    </h6>
                    {editing && (
                      <p className="ps-card-subtitle">
                        Coordinates: {editedData.latitude}, {editedData.longitude}
                      </p>
                    )}
                  </div>
                </div>
                <div style={{ borderRadius: "0 0 14px 14px", overflow: "hidden" }}>
                  <iframe
                    title="dealer-map"
                    width="100%"
                    height="260"
                    frameBorder="0"
                    style={{ border: 0, display: "block" }}
                    src={`https://www.google.com/maps?q=${encodeURIComponent(editedData.latitude)},${encodeURIComponent(editedData.longitude)}&z=15&output=embed`}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}

            {/* â”€â”€ Account Details â”€â”€ */}
            <div className="ps-card">
              <div className="ps-card-header">
                <div>
                  <h6 className="ps-card-title">
                    <i className="fa-solid fa-circle-info me-2" style={{ color: "#00889c" }}></i>
                    Account Details
                  </h6>
                </div>
              </div>
              <div className="ps-info-grid">
                <div className="ps-info-item">
                  <span className="ps-info-label"><i className="fa-solid fa-calendar me-1"></i>Member Since</span>
                  <span className="ps-info-value">{moment(data?.data?.created_at).format("D MMM YYYY")}</span>
                </div>
                <div className="ps-info-item">
                  <span className="ps-info-label"><i className="fa-solid fa-fingerprint me-1"></i>User ID</span>
                  <span className="ps-info-value">Car-{data?.data?.id}</span>
                </div>
                <div className="ps-info-item">
                  <span className="ps-info-label"><i className="fa-solid fa-circle-check me-1"></i>Status</span>
                  <span className="ps-status-badge">Active</span>
                </div>
              </div>
            </div>

            {/* â”€â”€ Danger Zone â”€â”€ */}
            <div className="ps-danger-zone">
              <p className="ps-danger-text">Permanently remove your dealer account and all associated listings.</p>
              <Link to="/deleteAccount" className="ps-danger-btn">
                <i className="fa-solid fa-trash me-2"></i>Delete My Account
              </Link>
            </div>

          </div>
        </div>
      </div>

      <Footer />

      {/* â”€â”€ Crop Modal â”€â”€ */}
      <div className="modal fade" id="cropModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crop Your Photo</h5>
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
            <div className="modal-body">
              <div style={{ position: "relative", height: "300px", width: "100%" }}>
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary btn-sm" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary btn-sm" onClick={handleCropImage}>
                <i className="fa-solid fa-crop me-1"></i>Crop &amp; Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default EditDealerProfile;
